function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import rgba from 'polished/lib/color/rgba';
var commonOptions = _ref => {
  var _options$title;
  var {
    options,
    theme
  } = _ref;
  var text = (_options$title = options.title) === null || _options$title === void 0 ? void 0 : _options$title.text;
  var fontWeightStyle = {
    style: {
      fontWeight: 'normal'
    }
  };
  var fontFamily = {
    fontFamily: theme.typography.family0
  };
  var linkStyle = {
    color: theme.palette.primary.default,
    fontSize: theme.typography.size0,
    lineHeight: theme.typography.lineHeight1,
    textDecoration: 'none'
  };
  return {
    annotations: {
      // @ts-expect-error label does not exist in type AnnotationsOptions
      label: fontWeightStyle,
      labelOptions: fontWeightStyle
    },
    chart: {
      backgroundColor: theme.palette.background.container,
      style: fontFamily
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          symbol: 'download',
          symbolFill: theme.palette.primary.default,
          // @ts-expect-error symbolStroke does not exist in type ExportingButtonsOptionsObject
          symbolStroke: theme.palette.primary.default,
          symbolStrokeWidth: 0
        }
      },
      chartOptions: {
        chart: {
          style: fontFamily
        },
        legend: {
          itemDistance: 30,
          itemMarginBottom: 4
        },
        xAxis: {
          labels: {
            style: {
              fontSize: '11px'
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: _objectSpread(_objectSpread({}, linkStyle), {}, {
        fontWeight: 'normal'
      }),
      activeDataLabelStyle: _objectSpread(_objectSpread({}, linkStyle), {}, {
        fontWeight: 'normal'
      }),
      drillUpButton: {
        theme: {
          'stroke-width': 0,
          fill: 'transparent',
          states: {
            hover: {
              fill: 'transparent',
              style: {
                textDecoration: 'underline'
              }
            }
          },
          style: _objectSpread(_objectSpread({}, linkStyle), {}, {
            color: theme.palette.foreground.light,
            fontSize: theme.typography.size2,
            fontWeight: 'bold',
            lineHeight: theme.typography.lineHeight2,
            textTransform: 'uppercase'
          })
        }
      }
    },
    legend: {
      itemStyle: {
        fontWeight: 'normal'
      },
      title: fontWeightStyle
    },
    loading: {
      labelStyle: {
        fontWeight: 'normal'
      }
    },
    navigation: {
      buttonOptions: {
        theme: {
          fill: theme.palette.background.container,
          // @ts-expect-error states does not exist in type NavigationButtonThemeOptions
          states: {
            hover: {
              fill: theme.palette.primary.backgroundLight
            },
            select: {
              fill: theme.palette.primary.background
            }
          }
        }
      },
      menuStyle: {
        background: theme.palette.background.container,
        border: theme.mode === 'contrast' ? "1px solid ".concat(theme.palette.primary.default) : 0,
        borderRadius: theme.borderRadius3,
        boxShadow: "0 8px 24px ".concat(rgba(theme.color.gray10, 0.1)),
        display: 'inline-block',
        marginTop: theme.orbitalTwo,
        minWidth: '180px',
        overflow: 'hidden',
        paddingBottom: 0,
        paddingTop: 0,
        whiteSpace: 'nowrap'
      },
      menuItemStyle: {
        color: theme.palette.foreground.default,
        fontSize: theme.fontSizeThree
      },
      menuItemHoverStyle: {
        background: theme.palette.primary.default,
        border: 0,
        color: theme.palette.foreground.inverse,
        fontSize: theme.fontSizeThree
      }
    },
    noData: {
      style: _objectSpread(_objectSpread({}, fontWeightStyle.style), {}, {
        color: theme.palette.foreground.light,
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      })
    },
    plotOptions: {
      column: {
        label: fontWeightStyle
      },
      // @ts-expect-error has no properties in common with type PlotLineOptions
      line: fontWeightStyle,
      pie: {
        dataLabels: fontWeightStyle
      },
      series: {
        cursor: 'pointer'
      },
      solidgauge: {
        dataLabels: fontWeightStyle
      },
      wordcloud: fontWeightStyle
    },
    series: {
      // @ts-expect-error column does not exist in type SeriesOptionsType[]
      column: {
        dataLabels: fontWeightStyle,
        label: fontWeightStyle
      },
      line: {
        dataLabels: fontWeightStyle,
        label: fontWeightStyle
      },
      pie: {
        dataLabels: fontWeightStyle,
        label: fontWeightStyle
      },
      wordcloud: fontWeightStyle
    },
    subtitle: {
      style: {
        color: theme.palette.foreground.light,
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      }
    },
    title: {
      align: 'center',
      margin: 35,
      style: {
        color: theme.palette.foreground.default,
        fontSize: theme.typography.size3,
        lineHeight: theme.typography.lineHeight3,
        textAlign: 'center'
      },
      text
    },
    tooltip: {
      borderWidth: 0,
      style: _objectSpread(_objectSpread({}, fontFamily), {}, {
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      })
    },
    yAxis: {
      stackLabels: fontWeightStyle
    },
    scrollbar: {
      barBackgroundColor: theme.colorChartScrollbar,
      // @ts-expect-error string is not assignable to type number
      barBorderRadius: theme.borderRadius2,
      buttonArrowColor: 'transparent',
      buttonBackgroundColor: 'transparent',
      buttonBorderColor: 'transparent',
      rifleColor: 'trasnparent',
      size: 8,
      trackBackgroundColor: 'none',
      trackBorderColor: 'none'
    }
  };
};
export default commonOptions;